/* global axios */
import ApiClient from './ApiClient';

class WonReasonsAPI extends ApiClient {
  constructor() {
    super('won_reasons', { accountScoped: true });
  }

  getAll(activeOnly = false) {
    const params = activeOnly ? { active_only: true } : {};
    return axios.get(this.url, { params });
  }
}

export default new WonReasonsAPI();
